import { render } from "./BerkebutuhanKhusus.vue?vue&type=template&id=7cd3a1b9"
import script from "./BerkebutuhanKhusus.vue?vue&type=script&lang=js"
export * from "./BerkebutuhanKhusus.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__